import React from "react";

const updates = [
  {
    date: "May 2026",
    type: "Product Update",
    title: "Budget Planner now supports household sync and role-based collaboration",
    summary: "Launched shared household workflows with member management, transaction sync, and collaborative planning modes.",
  },
  {
    date: "Apr 2026",
    type: "Platform",
    title: "Expanded trust and security documentation",
    summary: "Published a dedicated Trust & Security page detailing encryption, data handling, and infrastructure commitments.",
  },
  {
    date: "Mar 2026",
    type: "Consulting",
    title: "Introduced Assess -> Build -> Scale consulting model",
    summary: "New structured engagement framework for teams that need strategy, implementation, and ongoing advisory support.",
  },
  {
    date: "Feb 2026",
    type: "Milestone",
    title: "10,000+ tool runs completed",
    summary: "Crossed a major usage milestone as adoption grew across finance, analytics, and productivity tool categories.",
  },
  {
    date: "Jan 2026",
    type: "Infrastructure",
    title: "Performance optimization on edge runtime",
    summary: "Improved average response times and reduced cold-start variance across global Cloudflare regions.",
  },
];

export default function Newsroom() {
  return (
    <div className="min-h-screen bg-white">
      <section className="bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 text-white py-24">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-indigo-300 font-semibold uppercase tracking-widest text-sm mb-5">Newsroom</p>
          <h1 className="text-5xl font-extrabold mb-6 leading-tight">Company Updates & Announcements</h1>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto leading-relaxed">
            A transparent timeline of product launches, milestones, and platform improvements.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4">
          <div className="space-y-5">
            {updates.map((u) => (
              <article key={u.title} className="border border-gray-100 rounded-2xl p-6 shadow-sm hover:shadow-md transition bg-white">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <span className="text-xs font-bold bg-indigo-50 text-indigo-600 px-2.5 py-1 rounded-full">{u.type}</span>
                  <span className="text-xs font-semibold text-gray-400 uppercase tracking-widest">{u.date}</span>
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">{u.title}</h2>
                <p className="text-sm text-gray-500 leading-relaxed">{u.summary}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50 border-t border-gray-100 text-center">
        <div className="max-w-2xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Want updates in your inbox?</h2>
          <p className="text-gray-500 mb-6">We share product updates, release notes, and consulting insights regularly.</p>
          <a href="mailto:[email protected]?subject=Subscribe%20to%209nd.org%20updates" className="inline-block bg-indigo-600 text-white font-bold px-8 py-3.5 rounded-xl hover:bg-indigo-700 transition">
            Subscribe to Updates →
          </a>
        </div>
      </section>
    </div>
  );
}
